<mat-form-field class="form-element" appearance="fill">
  <mat-label>packaging @if (fieldName) { [{{ fieldName }}] }</mat-label>
  <input type="text" placeholder="Search packaging" matInput [formControl]="packagingControl" [matAutocomplete]="auto" required
    (focus)="onFocus($event.target.value)" (blur)="updatePackaging($event.target.value)"
    (input)="packagingChanges.next($event.target.value)" />
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setPackagingChangeAction($event)">
    @for (option of packagingSuggestions | async; track option) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (packagingControl.hasError('noOption')) {
    <mat-error>
      Packaging not Found
    </mat-error>
  }
</mat-form-field>
<mat-slide-toggle #packagingToggle>Show dimensions</mat-slide-toggle>

<div class="form-wrapper__packaging" [hidden]="!packagingToggle.checked">
  <div class="form-wrapper__packaging-inner"></div>
  <mat-form-field class="form-element">
    <mat-label>Packaging Width @if (fieldName) { [{{ fieldName }}.subType.W] }</mat-label>
    <input [value]="packagingWidth" matInput disabled placeholder="Packaging Width">
  </mat-form-field>

  <mat-form-field class="form-element">
    <mat-label>Packaging Height @if (fieldName) { [{{ fieldName }}.subType.H] }</mat-label>
    <input [value]="packagingHeight" matInput disabled placeholder="Packaging Height">
  </mat-form-field>

  <mat-form-field class="form-element">
    <mat-label>Packaging Length @if (fieldName) { [{{ fieldName }}.subType.L] }</mat-label>
    <input [value]="packagingLength" matInput disabled placeholder="Packaging Length">
  </mat-form-field>

  <mat-form-field class="form-element">
    <mat-label>Packaging Weight @if (fieldName) { [{{ fieldName }}.weight] }</mat-label>
    <input [value]="packagingWeight" matInput disabled placeholder="Packaging Weight">
  </mat-form-field>
</div>
